<template>
  <router-view />
  <global-alert />
</template>

<script setup>
  import { watch } from "vue";
  import { useCurrentUser } from "vuefire";
  import GlobalAlert from "./components/GlobalAlert.vue";
  import { useOnboardingCheck } from "./composables/onboardingCheck";
  import { useAdminAccessStore } from "@/store/adminAccess";

  useOnboardingCheck();

  const currentUser = useCurrentUser();
  const adminAccessStore = useAdminAccessStore();

  watch(
    () => currentUser.value,
    async (user) => {
      if (!user) {
        adminAccessStore.clear();
        return;
      }

      try {
        await adminAccessStore.ensureLoaded(user);
      } catch (error) {
        console.error("Failed to preload admin access:", error);
      }
    },
    { immediate: true },
  );
</script>
